// Generated from assets/EmptyState/no_search_results.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const NoSearchResults = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg width={171} height={95} fill='none' viewBox='0 0 171 95' {...props}>
      <G clipPath={`url(#${uid}-a)`}>
        <Path
          fill='#E8E8E8'
          d='M81.785 92.509c42.91 0 77.695-2.57 77.695-5.74s-34.785-5.74-77.695-5.74-77.695 2.57-77.695 5.74 34.785 5.74 77.695 5.74'
        />
        <Path
          fill='#303742'
          d='M133.105 9.415a8.707 8.707 0 0 1 8.85 8.57V77.79a7.497 7.497 0 0 1-7.6 7.37H50.1a7.5 7.5 0 0 1-7.6-7.37V7.74A7.5 7.5 0 0 1 50.1.37h32.5c5.155 0 9.33 4.055 9.33 9.05h41.175z'
        />
        <Path
          fill='#231F20'
          d='M134.385 85.409h-84.24a7.745 7.745 0 0 1-7.85-7.62V7.739a7.745 7.745 0 0 1 7.85-7.62h32.5c5.195 0 9.44 4.04 9.575 9.055h40.93c5 0 9.08 3.955 9.08 8.815v59.8a7.744 7.744 0 0 1-7.845 7.62M50.145.614a7.245 7.245 0 0 0-7.35 7.125v70.05a7.244 7.244 0 0 0 7.35 7.12h84.24a7.245 7.245 0 0 0 7.35-7.12V17.984c0-4.585-3.85-8.32-8.585-8.32H92a.25.25 0 0 1-.25-.25c0-4.85-4.075-8.8-9.08-8.8z'
        />
        <Path
          fill='#00D9A5'
          d='M76.185 26.209h85.905c3.735 0 5.72 2.595 4.425 5.795l-19.32 47.805c-1.29 3.2-5.37 5.795-9.105 5.795H52.18c-3.735 0-5.715-2.595-4.42-5.795l19.315-47.805c1.295-3.2 5.37-5.795 9.11-5.795'
        />
        <Path
          fill='#035B60'
          d='M158.35 35.37h-26.76a2 2 0 0 0-1.62.826l-2.173 3c-.957 1.323-.012 3.173 1.62 3.173h26.544c.609 0 1.185-.277 1.564-.754l2.39-3c1.043-1.31.11-3.246-1.565-3.246'
        />
        <Path
          fill='#168E95'
          d='M56.846 46.327 51.48 43.18 45.5 53.382l5.366 3.146z'
        />
        <Path
          fill='white'
          fillOpacity={0.8}
          d='M64.106 44.259c8.44 0 15.28-6.842 15.28-15.28 0-8.44-6.84-15.28-15.28-15.28s-15.28 6.84-15.28 15.28c0 8.438 6.841 15.28 15.28 15.28'
        />
        <Path
          fill='#FFD200'
          fillRule='evenodd'
          d='M85.716 28.98c0 11.934-9.675 21.61-21.61 21.61s-21.61-9.676-21.61-21.61c0-11.936 9.675-21.61 21.61-21.61s21.61 9.674 21.61 21.61m-6.33-.002c0 8.44-6.84 15.28-15.28 15.28s-15.28-6.84-15.28-15.28c0-8.438 6.841-15.28 15.28-15.28s15.28 6.842 15.28 15.28'
          clipRule='evenodd'
        />
        <Path
          fill='#035B60'
          d='m52.558 53.633-5.254-3.08a2.555 2.555 0 0 0-3.496.912L33.792 68.551a2.555 2.555 0 0 0 .912 3.496l5.254 3.08a2.555 2.555 0 0 0 3.496-.912L53.47 57.129a2.555 2.555 0 0 0-.912-3.496'
        />
      </G>
      <Defs>
        <ClipPath id={`${uid}-a`}>
          <Path fill='white' d='M0 .37h171v94H0z' />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
